import React from 'react';
import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox';
import InputField from '../../../components/InputField';
import TextArea from '../../../components/TextArea';
import Typography from '../../../components/Typography';
import { SurveyUploadData } from '../../../models/Survey';

type Props = {
    data: SurveyUploadData;
    handleSubmit: (data: SurveyUploadData) => void;
};

const SurveyFileuploadDetail: React.FC<Props> = ({ data, handleSubmit }) => {
    const [detail, setDetail] = React.useState(data);

    React.useEffect(() => {
        setDetail(data);
    }, [data]);

    const handleChange = (name: string, value: string | boolean) => {
        setDetail({ ...detail, [name]: value });
    };

    return (
        <div className="detail">
            <Typography variant="subtitle" color="primary">
                FILE UPLOAD DETAILS
            </Typography>
            <hr />
            <Typography variant="body">Please provide title for the form field.</Typography>
            <InputField onChange={handleChange} name="title" value={detail.title} />
            <Typography variant="body">Please provide description if applicable.</Typography>
            <TextArea onChange={handleChange} name="description" value={detail.description} />
            <Checkbox
                onChange={() => handleChange('isMultiple', !detail.isMultiple)}
                label={'Allow multiple file uploads'}
                checked={detail.isMultiple ? detail.isMultiple : false}
            />
            <Checkbox
                onChange={() => handleChange('required', !detail.required)}
                label={'This is a required field'}
                checked={detail.required ? detail.required : false}
            />
            <div className="action-container">
                <Button onClick={() => handleSubmit(detail)}>Update Item</Button>
            </div>
        </div>
    );
};

export default SurveyFileuploadDetail;
